import {request, _urlStatus, _urlFilters} from "../api";
import {STATUS_CONSTS} from "../constants";
import swal from "sweetalert";
import {history} from "../../configs/history";
import {notificationSuccess} from "../../components/uiElements/Notifications";

export const GetStatuses = () => {
    const requestData = {
        url: _urlStatus,
        token: true,
        method: "GET",
    };

    return dispatch => {
        return request(requestData)
            .then(({data}) => {
                dispatch({
                    type: STATUS_CONSTS.GET_STATUSES,
                    payload: data
                });
            })
    }
};


export const DeleteStatusById = id => {
    const requestData = {
        url: `${_urlStatus}/${id}`,
        token: true,
        method: "DELETE",
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                dispatch({
                    type: STATUS_CONSTS.DELETE_STATUS_BY_ID,
                    payload: id
                });
            })
    }
};

export const CreateStatus = data => {
    const requestData = {
        url: _urlStatus,
        token: true,
        method: "POST",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: STATUS_CONSTS.CREATE_STATUS,
                    payload: res?.data
                });
                notificationSuccess({
                    description: "Կարգավիճակը հաջողությամբ ստեղծվեց!"
                })
                history.push('/status')
            })
    }
};

export const UpdateStatusById = (id, data) => {
    const requestData = {
        url: `${_urlStatus}/${id}`,
        token: true,
        method: "PATCH",
        data,
    };
    return dispatch => {
        return request(requestData)
            .then(res => {
                dispatch({
                    type: STATUS_CONSTS.UPDATE_STATUS,
                    payload: res?.data
                });
                notificationSuccess({
                    description: "Կարգավիճակը հաջողությամբ փոփոխվեց!"
                })
                history.push('/status')
            })
    }
};

export const UpdateStatusesPositions = items => {
    const requestData = {
        url: _urlStatus,
        token: true,
        method: "PUT",
        data: items
    };
    return dispatch => {
        return request(requestData)
            .then(() => {
                notificationSuccess({
                    description: "Կարգավիճակը հաջողությամբ փոփոխվեց!"
                })
            })
    }
};
